import request from "./curl";
import message from "../components/chat_msg_view";
import confirmation_dialog from "../components/confirmation_dialog";

export default {
  props: ["participant_is_admin", "currentItem"],
  name: 'channels',
  components: {message, confirmation_dialog},
  data () {
    return {
      channels: [],
      dialog: false,
      new_tag: '',
      tag_type: 0,
      loading: false,
      headline1: '',
      headline2: '',
      show_conf_dialog: false,
      message1: '',
      message2: '',
      delete_tag: {},
      err_msg: '',
      snackbar: false,
      selected_channel: 0,
      reload_msg:0,
      chatContainerStyleObj:{}
    }
  },
  computed: {
    userData() {
      return this.$store.getters.userData;
    },
    async selectedGroup() {
      return await this.$store.getters.selectedGroup;
    },
    selectedTag() {
      return this.$store.getters.getSelectedTag;
    },
    getClientDeviceHeight(){
      return this.$store.getters.getClientDeviceHeight;
    }
  },
  mounted () {
    this.chatContainerStyleObj = {
      'height': `${this.getClientDeviceHeight - 160}px`,
      'background-color':'#fafafa',
      'margin-top':'104px'
    };
    this.get_channels();
  },
  methods: {
    /**
     * get_channels
     */
    async get_channels() {
      var post_data = new FormData();
      post_data.append("user_id", this.userData.user_id);
      post_data.append("tag_type", 1);
      post_data.append("group_id", await this.selectedGroup);

      request.curl(this, "chat_tag_list", post_data)
        .then(response => {
          if(response.resp_status){
            this.channels = response.resp_data;
            this.$store.commit('setSelectedTag', {
              'name': this.channels[0].name,
              'type': 1
            });
          }
        });
    },
    /**
     * add_tag
     */
    async add_tag() {
      let selectedGroupId = await this.selectedGroup;
      this.loading = true;
      let ws = new RegExp(/^\s+$/);
      let re = /[^A-Z0-9]/gi;

      let error = false;

      if(re.test(this.new_tag)) {
        error = true;
        this.err_msg = 'Special characters are not allowed in tags';
      }

      let tag = '#'+this.new_tag;

      if(this.new_tag && !ws.test(this.new_tag)){
        if(this.new_tag.length < 4) {
          error = true;
          this.err_msg = 'Minimum tag length is 4 characters';
        }

        let tags = this.channels;

        for(let chn in tags) {
          if(tags[chn].name == tag.toLowerCase()){
            error = true;
            this.err_msg = 'Already exists.';
            break;
          }
        }
      }
      else{
        error = true;
        this.err_msg = 'Input is Mandatory';
      }

      if(error) {
        this.snackbar = true;
        this.loading = false;
        return false;
      }
      else{
        var post_data = new FormData();
        post_data.append("user_id", this.userData.user_id);
        post_data.append("tag_type", 1);
        post_data.append("tag_name", tag);
        post_data.append("group_id", selectedGroupId);

        request.curl(this, "chat_tag_add", post_data)
        .then(async response => {
          if(response.resp_status){
            let tag_obj = {
              'name': tag,
              'type': this.tag_type
            };
            let tag_id = this.channels.length;

            tag_obj.group_id = selectedGroupId;
            this.channels.push(tag_obj);

            this.selected_channel = tag_id;

            this.$store.commit('setSelectedTag', {
              'name': tag,
              'type': 1
            });

            this.err_msg = 'Added.';
            this.snackbar = true;
            this.cancel();
          }
          else{
            this.err_msg = 'Unable to add';
            this.snackbar = true;
            this.loading = false;
          }
        });
      }
    },
    /**
     * select_tag
     */
    select_tag(tag, type) {
      if(this.selectedTag && (this.selectedTag.type == type && this.selectedTag.name == tag)) {
        this.$store.commit('setSelectedTag', null);
      }else {
        let selected_tag = {
          'name': tag,
          'type': type
        };
        this.$store.commit('setSelectedTag', selected_tag);
      }
    },
    /**
     * remove
     */
    remove() {
      const index = this.channels.indexOf(this.delete_tag);
      if (index > -1) {
        this.channels.splice(index, 1);
        this.tag_delete();
      }
    },
    /**
     * tag_delete
     */
    async tag_delete() {
      var post_data = new FormData();
      post_data.append("user_id", this.userData.user_id);
      post_data.append("tag_type", 1);
      post_data.append("tag_name", this.delete_tag.name);

      post_data.append("group_id", await this.selectedGroup);

      request.curl(this, "chat_tag_delete", post_data)
      .then(response => {
        if(response.resp_status){
          if(this.selectedTag && (this.selectedTag.name == this.delete_tag.name &&
            this.selectedTag.type == 1)){

            if(this.channels.length > 0) {
              this.$store.commit('setSelectedTag', this.channels[0]);
              this.selected_channel = 0;
            }else{
              this.$store.commit('setSelectedTag', null);

            }

          }
          this.err_msg = 'Deleted.';
          this.snackbar = true;
          this.cancel();
        }
        else{
          this.err_msg = 'Unable to delete';
          this.snackbar = true;
        }
      });
    },
    /**
     * conf_dialog
     */
    conf_dialog(tag) {
      this.headline1 = "Delete Channel";
      this.headline2 = "Delete Channel";
      this.message1 = "Are you sure you want to delete the " +tag.name+ " Channel?";
      this.message2 = "Deleting this Channel will remove all messages and all media from this Channel.";
      this.delete_tag = tag;
      this.show_conf_dialog = true;
    },
    /**
     * open_dialog
     */
    open_dialog(type) {
      this.tag_type = type;
      this.dialog = true;
    },
    /**
     * cancel
     */
    cancel() {
      this.dialog = false;
      this.new_tag = '';
      this.loading = false;
    },
    /**
     * conf_dialog_closed
     */
    conf_dialog_closed() {
      this.show_conf_dialog = false;
    },
    /**
     * agree
     */
    agree() {
      this.show_conf_dialog = false;
      this.remove();
    }
  },
  watch: {
    /**
     * selectedTag: Watch which tag is selected for the group
     */
    selectedTag: function () {
      if (!this.selectedTag) {
        this.selected_channel = -1;
      }else{
        if(this.selectedTag.type == 1){
          this.reload_msg += 1;
        }
      }
    },
    currentItem: function () {
      if(this.currentItem == 1) {
        if(this.selected_channel == -1) {
          this.selected_channel = 0;
        }
        if(this.channels.length > 0) {
          this.$store.commit('setSelectedTag', {
            'name': this.channels[this.selected_channel].name,
            'type': 1
          });
        }
      }
    }
  }
}